import { render, staticRenderFns } from "./IconSvgPresentation.vue?vue&type=template&id=d4b409c0&scoped=true&"
import script from "./IconSvgPresentation.vue?vue&type=script&lang=js&"
export * from "./IconSvgPresentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b409c0",
  null
  
)

export default component.exports